var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcJammer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#82042e;}.cls-3{fill:#7e0100;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-Jammer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9",
    "data-name": 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.31,181.33H86c-4.52,0-8-1.25-10.49-3.71s-3.68-6-3.68-10.52q0-32.26,0-64.51v-2.09c0-8.41,3.57-12.77,12-14.59l.35-.07H150l.23,0c4.91.69,8.41,2.83,10.4,6.35,1.58,2.8,2.15,6.4,1.74,11,0,3,.05,49.38.05,63.63,0,9.46-5,14.46-14.56,14.46H114.31ZM84.8,92.47c-5.12,1.16-6.38,2.8-6.38,8v2.08q0,32.25,0,64.51c0,5.46,2.11,7.59,7.53,7.59h61.93c5.92,0,7.92-2,7.92-7.82h0c0-14.65-.05-63.28-.05-63.77v-.31c.72-7.61-1.84-9.62-6.22-10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.27,126.73a4.76,4.76,0,0,1-.16-9.51,4.9,4.9,0,0,1,4.67,4.53A4.83,4.83,0,0,1,145.27,126.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.77,107.61a4.66,4.66,0,1,1-9.32.13,4.66,4.66,0,0,1,9.32-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09,92.54a3.32,3.32,0,0,1-3.32-3.32V46.41a3.32,3.32,0,0,1,6.64,0V89.22A3.32,3.32,0,0,1,88.09,92.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.18,92.47a3.32,3.32,0,0,1-3.32-3.32V55.34a3.32,3.32,0,1,1,6.64,0V89.15A3.32,3.32,0,0,1,108.18,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,92.47a3.32,3.32,0,0,1-3.32-3.32V55.34a3.32,3.32,0,0,1,6.64,0V89.15A3.32,3.32,0,0,1,126.48,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,92.47a3.32,3.32,0,0,1-3.32-3.32V55.34a3.32,3.32,0,0,1,6.64,0V89.15A3.32,3.32,0,0,1,145.12,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,129.69c-.15-2,0-22.27,0-26.32l6.64,0c0,9.25-.11,24.43,0,25.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJammer);
export default __webpack_public_path__ + "static/media/ic-Jammer.440290dd3801a7206cff048b2d57a0f8.svg";
export { ForwardRef as ReactComponent };